import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { Progress } from '@core/models/progress';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-progress-dialog',
  templateUrl: './progress-dialog.component.html',
  styleUrls: ['./progress-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressDialogComponent implements OnInit {
  speed: string;
  unit: string;
  percentDone: number;
  progress$: Observable<{ speed: string, unit: string, percentDone: number }>;

  constructor(
    public dialogRef: MatDialogRef<ProgressDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      progress$: Observable<Progress>,
      initTitle: string,
      progressTitle: string,
      completionTitle: string,
      isInferiorBrowser$: Observable<boolean>
    }
  ) { }

  ngOnInit() {
    this.progress$ = this.data.progress$.pipe(map((res) => ({
      speed: Number.isNaN(res.speed) || !Number.isFinite(res.speed) ? '0' : res.speed.toFixed(2),
      unit: res.unit,
      percentDone: res.percentDone
    })));
  }

  cancel() {
    this.dialogRef.close();
  }
}
